module.exports = __webpack_public_path__ + "static/TeamAugmentation-banner-df8c6d631e264f534872adb74bec849a.png";